import React, {Component} from 'react';
import classNames from 'classnames';
import style from "./_fands.module.scss";
import {ButtonGroup} from "reactstrap";
import NTMButton from "../Buttons/NTMButton";

export default class NTMButtonRow extends Component {

	render() {
		const {buttons, allButton=true, onClick, selected} = this.props;
		return (
			<ButtonGroup className={classNames(style.buttonRow)}>
				{
					allButton &&
						<NTMButton
							onClick={() => {this.setState({selected: null}); onClick && onClick(null)}}
							primary={selected === null}
							unselected={selected !== null ? "true" : undefined}
						>
							Tutti
						</NTMButton>
				}
				{
					buttons.map((name) =>
						<NTMButton
							onClick={() => {this.setState({selected: name}); onClick && onClick(name)}}
							primary={selected === name}
							unselected={selected !== name ? "true" : undefined}
							key={name}
						>
							{name}
						</NTMButton>
					)
				}
			</ButtonGroup>
		);
	}
}
